import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "@/components/site/Reveal";
import { FAQ_ITEMS, waLink } from "@/lib/data";
import { useLang } from "@/lib/i18n";

const Faq = () => {
    const { tr } = useLang();
    return (
        <div data-testid="faq-page" className="pt-28 md:pt-36">
            <section className="pb-24 md:pb-32">
                <div className="max-w-4xl mx-auto px-6 md:px-12">
                    <Reveal>
                        <Overline>{tr("Questions fréquentes", "Frequently asked questions")}</Overline>
                        <h1 className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
                            {tr("Tout ce que tu te", "Everything you're")}{" "}
                            <span className="font-accent italic font-medium text-ochre">{tr("demandes.", "wondering.")}</span>
                        </h1>
                    </Reveal>

                    <Reveal delay={0.12} className="mt-12">
                        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                            {FAQ_ITEMS.map((item, i) => (
                                <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
                                    <AccordionTrigger
                                        className="text-left font-heading text-lg md:text-xl font-bold tracking-tight hover:text-terracotta hover:no-underline py-6"
                                        data-testid={`faq-question-${i}`}
                                    >
                                        {tr(item.q)}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-sand leading-relaxed font-light pb-6" data-testid={`faq-answer-${i}`}>
                                        {tr(item.a)}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </Reveal>

                    <Reveal delay={0.2} className="mt-16">
                        <div className="border border-white/10 bg-obsidian-surface p-8 md:p-10 text-center">
                            <h2 className="font-heading text-2xl md:text-3xl font-bold tracking-tight">
                                {tr("Une autre question ?", "Another question?")}
                            </h2>
                            <p className="mt-3 text-sand font-light">
                                {tr(
                                    "Écris-moi directement sur WhatsApp, je réponds personnellement.",
                                    "Message me directly on WhatsApp, I answer personally."
                                )}
                            </p>
                            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
                                <a
                                    href={waLink(tr(
                                        "Bonjour Coach Roméo, j'ai une question avant de me lancer.",
                                        "Hello Coach Roméo, I have a question before getting started."
                                    ))}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="faq-cta-whatsapp"
                                    className="inline-flex items-center justify-center gap-3 rounded-full bg-whatsapp px-8 py-4 text-sm font-bold uppercase tracking-wider text-white transition-opacity duration-300 hover:opacity-90"
                                >
                                    {tr("Poser ma question", "Ask my question")} <ArrowRight className="h-4 w-4" />
                                </a>
                                <Link
                                    to="/contact"
                                    data-testid="faq-cta-consultation"
                                    className="inline-flex items-center justify-center gap-3 rounded-full border border-white/25 px-8 py-4 text-sm font-bold uppercase tracking-wider text-cream transition-colors duration-300 hover:border-ochre hover:text-ochre"
                                >
                                    {tr("Réserver une consultation", "Book a consultation")}
                                </Link>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
};

export default Faq;
